import { lazy } from 'react';
import { Navigate, Outlet, Route } from 'react-router-dom';

// const Dashboard = lazy(() => import('../pages/lms/dashboard/Dashboard').then(({ Dashboard }) => ({ default: Dashboard })))
const Report = lazy(() => import('../pages/lms/report/Report').then(({ Report }) => ({ default: Report })))
const PivotManage = lazy(() => import('../pages/lms/manage/PivotManage').then(({ PivotManage }) => ({ default: PivotManage })))
const MyCourses = lazy(() => import('../pages/lms/course/my_courses/MyCourses').then(({ MyCourses }) => ({ default: MyCourses })))
const CourseMain = lazy(() => import('../pages/lms/course/CourseMain').then(({ CourseMain }) => ({ default: CourseMain })))
const PivotDetail = lazy(() => import('../pages/lms/course/detail/PivotDetail').then(({ PivotDetail }) => ({ default: PivotDetail })))
const SubCatgeoryCourses = lazy(() => import('../pages/lms/course/sub_courses/SubCatgeoryCourses').then(({ SubCatgeoryCourses }) => ({ default: SubCatgeoryCourses })))
const ApprovalCourses = lazy(() => import('../pages/lms/approval/ApprovalCourses').then(({ ApprovalCourses }) => ({ default: ApprovalCourses })))
const MappingPreview = lazy(() => import('../pages/lms/approval/preview/MappingPreview').then(({ MappingPreview }) => ({ default: MappingPreview })))

export const lmsRoutes = () => {
  return (
    <Route path='/lms' element={<Outlet />}>
      <Route path="/lms" element={<Navigate to="/lms/my-coruse" replace />} />
      {/* <Route path="/lms/dashboard" element={(<Dashboard />)} /> */}
      <Route path="/lms/report" element={(<Report />)} />
      <Route path="/lms/my-courses" element={(<MyCourses />)} />

      <Route path="/lms/courses" element={(<CourseMain />)} />
      <Route path="/lms/courses/:id" element={(<SubCatgeoryCourses />)} />

      <Route path="/lms/manage-courses" element={(<PivotManage />)} />
      <Route path="/lms/manage-courses/kategori" element={(<PivotManage />)} />
      <Route path="/lms/manage-courses/preview" element={(<PivotManage />)} />
      <Route path="/lms/manage-courses/create" element={(<PivotManage />)} />
      <Route path="/lms/manage-courses/edit" element={(<PivotManage />)} />
      <Route path="/lms/manage-courses/view" element={(<PivotManage />)} />

      <Route path="/lms/course/:id/overview" element={(<PivotDetail />)} />
      <Route path="/lms/course/:id/learn" element={(<PivotDetail />)} />

      <Route path="/lms/approval" element={(<ApprovalCourses />)} />
      <Route path="/lms/approval/preview" element={(<MappingPreview />)} />
    </Route>
  );
}
